/**
 * Date and time formatting for the Cockpit.
 *
 * Two panels were each reaching for `toLocaleString(lang)` directly, which
 * looked identical until you noticed one of them used `toLocaleDateString` —
 * so the same column meant "when" in two different resolutions depending on
 * which screen you were reading (#133, #134). One helper, two named shapes.
 *
 * The visitor's locale comes from the active UI language rather than the
 * browser's, so switching the site to German switches the dates with it.
 */

/** A date alone: 27.08.2026 / 8/27/2026. For "which day did this happen". */
export function formatDate(value, lang, fallback = "—") {
  const date = toDate(value);
  return date ? date.toLocaleDateString(lang) : fallback;
}

/** Date and time: for log lines and "collected at", where the hour matters. */
export function formatDateTime(value, lang, fallback = "—") {
  const date = toDate(value);
  return date ? date.toLocaleString(lang) : fallback;
}

function toDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
